import { render } from "./ProjectManagerView.vue?vue&type=template&id=12d20826"
import script from "./ProjectManagerView.vue?vue&type=script&lang=js"
export * from "./ProjectManagerView.vue?vue&type=script&lang=js"

import "./ProjectManagerView.vue?vue&type=style&index=0&id=12d20826&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__